import { render, staticRenderFns } from "./ValveUpInstructions3.vue?vue&type=template&id=335ab2c2&"
import script from "./ValveUpInstructions3.vue?vue&type=script&lang=js&"
export * from "./ValveUpInstructions3.vue?vue&type=script&lang=js&"
import style0 from "./ValveUpInstructions3.vue?vue&type=style&index=0&id=335ab2c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports